import { render, staticRenderFns } from "./HelpQuestionsList.vue?vue&type=template&id=077674f6&"
import script from "./HelpQuestionsList.vue?vue&type=script&lang=js&"
export * from "./HelpQuestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports